module.exports = __webpack_public_path__ + "img/fluid-filler.0b6e8c71.svg";